export default {
  getAllProjects(state) {
    return state.projects;
  },

  shouldUpdate(state) {
    const lastStamp = state.lastFetch;
    if (!lastStamp) {
      return true;
    }
    const currentStamp = new Date().getTime();
    return (currentStamp - lastStamp) / 1000 > 60;
  },
};
